import React from "react"

class Dropdown extends React.Component {

	constructor(props) {
		super(props);

		this.onClickButton = this.onClickButton.bind(this);
		this.onClickOption = this.onClickOption.bind(this);
	}

	/**
	* Render functions
	*/

	render() {
		var self = this;
		var selectedOption = this.getSelectedOption();
		if (this.props.options && this.props.options.length > 1) {
			var options = this.props.options.map(function (option) {
				if (option.value != selectedOption.value) { // don't re-render the currently selected option
					return self.renderOption(option);
				}
			});
		}

		return (
      <div className={"dropdown " + this.props.className}>
        <a href="#" className={this.props.classes ? this.props.classes : "btn btn-sm btn-secondary dropdown-toggle form-control dashboard-dropdown"} style={this.props.style ? this.props.style : null} data-toggle="dropdown" onClick={this.onClickButton} >
          {selectedOption.name} <span className="caret"></span>
        </a>
        {
        	options && options.length > 0
        	?
        	<ul className="dropdown-menu">
        		{options}
        	</ul>
        	:
        	null
        }
      </div>
		);
	}

	renderOption(option) {
		return (
      <li key={option.value}>
        <a className={option.href ? "modal-iframe dropdown-item" : "dropdown-item"} 
           href={option.href ? option.href : "#"} 
           onClick={option.href ? null : this.onClickOption} 
           data-fullscreen={option.href ? true : null} 
           data-value={option.value}>
             {option.name}
        </a>
      </li>
		);
	}

	/**
	* Change handlers
	*/

	onClickButton(e) {
		// if (this.props.options && this.props.options.length > 1) {
		// 	e.stopPropagation();
		// 	e.preventDefault();
		// }
	}

	onClickOption(e) {
		if (this.props.onChange) {
			this.props.onChange(e.target.dataset.value);
		}
	}

	/**
	* Helper functions
	*/

	getSelectedOption() {
		if (this.props.options && this.props.options.length > 0) {
			for (var i = 0, ilen = this.props.options.length; i < ilen; i++) {
				if (this.props.options[i].value == this.props.value) {
					return this.props.options[i];
				}
			}
		}
	}

}

export default Dropdown